// My Contributions sub-page — App Flow §6.
import { Button, Card, EmptyState, FamilyChip, LoadingState, PageHeader } from '@roots/ui';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { api } from '../lib/api.js';
import { monthName } from '../lib/format.js';

export function ContributionsScreen() {
  const navigate = useNavigate();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['my-contributions'],
    queryFn: () => api.myContributions({ limit: 50 }),
  });

  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="My contributions" />

      {isLoading && <LoadingState onRetry={() => void refetch()} />}

      {!isLoading && (data?.contributions.length ?? 0) === 0 && (
        <EmptyState
          message="Your contributions will appear here once you start sharing."
          actions={
            <Button onClick={() => void navigate({ to: '/my-month' })}>Go to My Month</Button>
          }
        />
      )}

      <div className="flex flex-col gap-3">
        {data?.contributions.map((c) => (
          <Card key={c.id} className="flex flex-col gap-2">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <FamilyChip name={c.family_name} />
              <span className="type-caption">{monthName(c.cycle_year_month)}</span>
            </div>
            <p className="type-label">{c.prompt_text}</p>
            <p className="type-body line-clamp-3">{c.text_body ?? `${c.photos.length} photos`}</p>
            <div className="flex items-center justify-between gap-2">
              <span className="type-caption">{c.status === 'submitted' ? 'Shared' : 'Draft'}</span>
              <Button
                variant="ghost"
                onClick={() =>
                  c.edition_id
                    ? void navigate({
                        to: '/newsletter/$editionId',
                        params: { editionId: c.edition_id },
                      })
                    : void navigate({ to: '/my-month' })
                }
              >
                {c.edition_id ? 'Read it in the edition' : 'Open in My Month'}
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
